import { promo } from "./store"

const SPECIAL_PROMO_CODE = "16days"

function currentLocationSearch(): string {
  if (typeof window === "undefined") return ""

  return window.location.search
}

function specialNewsletterCampaign(params: URLSearchParams): boolean {
  return params.get("utm_campaign") === "16-days"
}

export function promoCodeFromSearch(search = currentLocationSearch()): string {
  const params = new URLSearchParams(search)
  const code = params.get("code")?.trim()

  if (params.has("code")) return code || ""
  if (specialNewsletterCampaign(params)) return SPECIAL_PROMO_CODE

  return ""
}

export function initializePromoFromLocation(search = currentLocationSearch()): void {
  const code = promoCodeFromSearch(search)

  promo.set({
    autoApply: Boolean(code),
    code,
    showField: Boolean(code),
    validation: null,
  })
}
